module.exports = __webpack_public_path__ + "img/mc.534760f2.svg";